import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "centered",
  style: {"margin-top":"100px","margin-bottom":"40px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "フォームの回答内容がありません。", -1)
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "rad8 pad5 mc posRe w100",
  style: {}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "fs14 grey fl mr10" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mr20 mr4 grey fs12 mt2",
  style: {}
}, "編集", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "fs14 fw600 ddgrey kaigyo"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 1,
  class: "fl"
}
const _hoisted_20 = {
  key: 0,
  class: "underline"
}
const _hoisted_21 = ["href"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["textContent"]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "fs14 grey" }, "同席者", -1)
const _hoisted_29 = { class: "fs14 fw600 ddgrey kaigyo" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserFileImage = _resolveComponent("UserFileImage")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.Util.isBlank(_ctx.results))
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
              width: "40",
              height: "40"
            }, null, 8, _hoisted_4)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (dic, dicindex) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "mb20",
                key: dicindex
              }, [
                (_ctx.Util.isDictionary(dic))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(dic.name), 1),
                      (!dic.file_dic && _ctx.canEdit && !_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "fl pointer",
                            onClick: ($event: any) => (_ctx.editStart(dicindex))
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
                              width: "14",
                              height: "14",
                              class: "ml1 fl mr5 mt2",
                              style: {}
                            }, null, 8, _hoisted_9),
                            _hoisted_10,
                            _hoisted_11
                          ], 8, _hoisted_8))
                        : _createCommentVNode("", true),
                      _hoisted_12,
                      (dic.file_dic)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_ctx.room)
                              ? (_openBlock(), _createBlock(_component_UserFileImage, {
                                  key: 0,
                                  file: dic.file_dic,
                                  showDeleteButton: true,
                                  type: `owner_modal`,
                                  hideDownloadLink: false,
                                  parentId: _ctx.room ? _ctx.room.id : null,
                                  onDeleted: _ctx.deletedAttachment
                                }, null, 8, ["file", "parentId", "onDeleted"]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                            (_ctx.editMode && dicindex == _ctx.editDicIndex)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  (_ctx.canEdit && _ctx.editMode)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        (['open_schedule_memo'].includes(dic.param_key))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                              _createVNode(_component_TextareaTag, {
                                                style: {"height":"80px"},
                                                class: "fl mr10 fs14 roundForm mw100",
                                                value: _ctx.edittingValue,
                                                onInputValue: _ctx.inputValue
                                              }, null, 8, ["value", "onInputValue"])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                              _createVNode(_component_MdTextfieldTag, {
                                                fieldStyle: "min-width:250px;max-width:250px;",
                                                style: {"height":"56px","min-width":"250px"},
                                                class: "fl mr10",
                                                type: `text`,
                                                value: _ctx.edittingValue,
                                                onInputValue: _ctx.inputValue
                                              }, null, 8, ["value", "onInputValue"])
                                            ])),
                                        _createElementVNode("div", {
                                          class: "fl skyblueBg rad5 mt16 fs11 pointer hoverGreyBg",
                                          style: {"padding":"13px","height":"40px"},
                                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.endEdit && _ctx.endEdit(...args)))
                                        }, " 完了 "),
                                        _createElementVNode("div", {
                                          class: "fl rad5 mt16 fs11 pointer underline",
                                          style: {"padding":"13px","height":"40px"},
                                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                                        }, " キャンセル ")
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (dic.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                    (_ctx.Util.isUrl(_ctx.Util.toString(dic.value)) && dic.value.includes(`http`))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                          _createElementVNode("a", {
                                            class: "skyblue",
                                            href: dic.value,
                                            target: "_blank"
                                          }, _toDisplayString(dic.value), 9, _hoisted_21)
                                        ]))
                                      : ((dic.value || ``).includes(`.waaq.jp`))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, "-"))
                                        : (_openBlock(), _createElementBlock("span", {
                                            key: 2,
                                            textContent: _toDisplayString(dic.value)
                                          }, null, 8, _hoisted_23))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_24, "-")),
                            _hoisted_25
                          ])),
                      _hoisted_26
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.attendees)
              ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("span", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendees, (att, attindex) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "fl",
                        key: attindex
                      }, [
                        _createElementVNode("span", null, _toDisplayString(att.name) + " (" + _toDisplayString(att.email) + ") ", 1),
                        _hoisted_30
                      ]))
                    }), 128)),
                    _hoisted_31
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}